<template>

    <div class="container bg-none block-control">

        <div class="row">

            <div class="col-12 col-lg-2 back-remove">

                <button @click="$router.back()" class="button-back"><span>Назад</span></button>

            </div>

            <div class="col-12 col-lg-9 ideas-list">

                <div class="remove-link">

                </div>

                <h1 class="page-title">Расширенный поиск</h1>


                <div v-if="searchResults.byTitle">
                    <p class="title-similar">Похожие темы</p>
                    <Idea :idea="idea" v-for="idea in searchResults.byTitle"></Idea>
                </div>
                <div v-if="searchResults.byDesc">
                    <p class="text-up">Упоминания в тексте</p>
                    <Idea :idea="idea" v-for="idea in searchResults.byDesc"></Idea>

                </div>

            </div>

        </div>

    </div>


</template>

<script>

    import Idea from './Idea'

    export default  {
        name: 'search-page',

        data() {
            return {
                term: ''
            }
        },

        computed: {
            searchResults() {
                return this.$store.state.searchResults
            }
        },

        methods: {
            search() {
            }
        },

        mounted() {
            if (this.$route.params.term) {
                this.$store.commit('SET_SEARCHTERM', this.$route.params.term);
                this.$store.dispatch('doSearch', this.$route.params.term).then((data) => {
                })
            }
        },

        components: {
            Idea
        }
    }
</script>


// WEBPACK FOOTER //
// SearchPage.vue?e8aec8b8